import { Menu } from '@/components/Menu';
import { UpdateCompanyGeneralIndex } from '@/partials/dashboard/Companies/UpdateCompany/General/UpdateCompanyGeneralIndex';
import { UpdateCompanyUserList } from '@/partials/dashboard/Companies/UpdateCompany/Users/UpdateCompanyUserList';
import { motion } from 'framer-motion';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      duration: 0.3,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.3 },
  },
};

export const UpdateCompany = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState(0);

  const sections = [
    {
      key: <UpdateCompanyGeneralIndex />,
      label: t('updateCompany:general.header'),
    },
    {
      key: <UpdateCompanyUserList />,
      label: t('updateCompany:users.header'),
    },
    // {
    //   key: <UpdateCompanyTeamsList />,
    //   label: t('updateCompany:teams.header'),
    // },
  ];

  const handleMenuClick = (index: number) => {
    setActiveSection(index);
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="h-full space-y-6 overflow-y-auto">
      {/* Header */}
      <motion.div
        className="flex flex-col gap-4 p-4"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {/* Header avec bouton retour */}
        <div className="flex items-center gap-3">
          <button
            onClick={handleBack}
            className="flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100"
          >
            <FaArrowLeft className="size-4" />
            {t('common:back')}
          </button>
          <div className="h-6 w-px bg-gray-300" />
          <h1 className="text-lg font-semibold text-secondary">
            {t('updateCompany:title')}
          </h1>
        </div>

        {/* Menu de navigation */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <Menu
            sections={sections}
            onSectionChange={handleMenuClick}
            className="overflow-x-auto"
          />
        </motion.div>
      </motion.div>

      {/* Contenu */}
      <motion.div
        className="px-4 pb-4"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.div
          key={activeSection}
          variants={itemVariants}
          initial="hidden"
          animate="visible"
        >
          {sections[activeSection].key}
        </motion.div>
      </motion.div>
    </div>
  );
};
